// SMS is in limited beta. Only these companies see the SMS surface: the
// sidebar nav item and the /sms/* routes. To roll SMS out to everyone, widen
// or remove this allowlist (single source of truth — don't hardcode the ids
// elsewhere).
export const SMS_BETA_COMPANY_IDS = [5, 7, 31, 78, 169, 227, 233, 243, 349];

/**
 * True when the signed-in company is in the SMS beta. Reads the company id
 * from localStorage (same key the rest of the app uses). Defaults to false on
 * any parse issue so the feature stays hidden by default.
 *
 * Note this gates VISIBILITY of the setup surface, which is separate from
 * `group.sms_active` (whether a given group finished carrier registration and
 * can actually send). Per-group SMS features still guard on sms_active.
 */
export function isSmsBetaCompany() {
  try {
    const id = Number(localStorage.getItem('companyId'));
    return SMS_BETA_COMPANY_IDS.includes(id);
  } catch (e) {
    return false;
  }
}
